import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { AppService } from 'app/main/services/app.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'list-products',
	templateUrl: './list-products.component.html',
	styleUrls: ['./list-products.component.scss']
})
export class ListProductsComponent implements OnInit{

	@Input() _isLoading: boolean;
	@Input() _response: any;
	@Input() _showPagination: boolean;
	@Output() changePage = new EventEmitter<any>(true);

	constructor(public appService: AppService, protected translate: TranslateService) {}

	ngOnInit(): void {}
}
